/**
 * 深度克隆一个对象
 * @param {*} obj
 */
//深度克隆
//深度克隆
export const deepClone = function (obj, cache = []) {
    // 判断原对象是否存在
    // if (obj) {
    //     var newObj = JSON.parse(JSON.stringify(obj));
    //     return newObj;
    // }
    // just return if obj is immutable value
    if (obj === null || typeof obj !== 'object') {
      return obj
    }
    const hit = cache.find(c => c.original === obj)
    if (hit) {
      return hit.copy
    }
  
    const copy = Array.isArray(obj) ? [] : {}
    cache.push({
      original: obj,
      copy
    })
  
    Object.keys(obj).forEach(key => {
      copy[key] = deepClone(obj[key], cache)
    })
  
    return copy
  }

  /**
 * 获取指定地址的经纬度,
 * @param {*} address
 */
export const getLocation = (address, Amap) => {
    return new Promise((resolve, reject) => {
      AMap.service('AMap.Geocoder', function() {
        let geocoder = new Amap.Geocoder({
          radius: 1000 //范围，默认：500
        });
        geocoder.getLocation(address, function(status, result) {
          if (status === 'complete' && result.info === 'OK') {
            resolve(result);
          } else {
            resolve(result.info);
            return result.info;
          }
        });
      });
    })
  }
  
var install  = {
    install(Vue){
        Vue.mixin({
            beforeCreate () {
                this.$deepClone = deepClone.bind(this);
                this.$getLocation = getLocation.bind(this);
            }
        })
    }
}

export default install;
//   export default {
//     version: '0.0.1',
//     install: function (Vue) {
//       Vue.prototype.$deepClone = deepClone;
//       Vue.prototype.$getLocation = getLocation;
     
//     },
//   }


// WEBPACK FOOTER //
// ./src/libs/js/deal_function.js